export default "__VITE_ASSET__Dc79yNTf__"